// Tooltip.js
import React from "react";

export default function Tooltip({ children, content, maxWidth = "150px", truncateLength = 15 }) {
  // Handle truncation
  const displayText =
    typeof children === "string" && children.length > truncateLength
      ? children.slice(0, truncateLength) + "..."
      : children;

  return (
    <div className="relative group" style={{ maxWidth }}>
      <div className="truncate text-sm text-gray-900">{displayText}</div>
      <div className="absolute left-0 top-full mt-1 hidden group-hover:flex z-50 bg-gray-900 text-white text-xs rounded px-2 py-1 shadow-lg whitespace-nowrap">
        {content}
      </div>
    </div>
  );
}
